import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "../hooks/useFavorites";

export function FavoriteButton({ text, showLabel = false, className = "", style = {} }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(text.id);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggleFavorite(text);
    toast.success(added ? "Guardado para leer luego." : "Quitado de tus guardados.");
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`favorite-button-${text.id}`}
      aria-pressed={active}
      aria-label={active ? "Quitar de guardados" : "Guardar para leer luego"}
      className={`inline-flex items-center gap-2 transition-colors hover:opacity-80 ${className}`}
      style={{ color: active ? "var(--rincon-primary)" : "var(--rincon-text-muted)", ...style }}
    >
      <Heart className="w-4 h-4" fill={active ? "currentColor" : "none"} />
      {showLabel ? (
        <span className="font-display text-lg">{active ? "Guardado" : "Guardar"}</span>
      ) : null}
    </button>
  );
}
